module.exports = __webpack_public_path__ + "img/gb9877_1-88-38x58x8.prt.5ef23d6a.jpg";